import type { PersonaDto } from '@/api-gen/api.schemas';

/**
 * Check if a persona is shared with other companies
 */
export const isPersonaShared = (persona: PersonaDto): boolean => {
  return typeof persona.otherCompaniesCount === 'number' && persona.otherCompaniesCount > 0;
};

/**
 * Get the number of other organizations (excluding the current user's organization)
 * a persona is shared with.
 */
export const getPersonaSharingCount = (persona: PersonaDto): number => {
  return Math.max(0, persona.otherCompaniesCount ?? 0);
};

/**
 * Check if a persona has sharing information available
 */
export const hasPersonaSharingInfo = (persona: PersonaDto): boolean => {
  return typeof persona.otherCompaniesCount === 'number';
};
